<template>
  <vx-card title="افزودن دانش آموز جدید">
    <avatar-uploader @change="avatarChanged" context="student" :user-id="0"></avatar-uploader>
    <form-student @save="saveStudent"></form-student>
  </vx-card>
</template>

<script>
  import FormStudent from "./FormStudent";
  import AvatarUploader from "../user/components/AvatarUploader";


  export default {
    name: "CreateStudent",
    components: {AvatarUploader, FormStudent},
    mounted() {
      //preload students for next redirect
      if (!this.$store.state.students.length)
        this.$store.dispatch('fetchStudents')

    },
    data() {
      return {
        uploadAvatarParams: null,
      }
    },
    methods: {
      saveStudent(student) {
        this.$store.dispatch('createStudent', student)
          .then((userId) => {
            if (this.uploadAvatarParams) {
              this.uploadAvatarParams.id = userId
              this.$store.dispatch('uploadProfileAvatar', this.uploadAvatarParams).then(url => {
                this.$vs.notify({
                  title: 'دانش آموز با موفقیت اضافه شد', text: '', color: 'success', position: 'top-center'
                })
                this.$router.push('/students')
              })
            } else {
              this.$vs.notify({
                title: 'دانش آموز با موفقیت اضافه شد', text: '', color: 'success', position: 'top-center'
              })
              this.$router.push('/students')
            }
          })
      },
      avatarChanged(params) {
        this.uploadAvatarParams = params
      }
    },
  }
</script>

<style scoped>

  .vs-input {
    width: auto !important;
    padding: 0 5px;
  }

</style>
